import { useEffect } from "react";
import HeaderImg from "../components/HeaderImg";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <HeaderImg title="Terms & Conditions" />
      <div className="legal">
        <div className="legal__container">
          <p className="legal__intro">
            By enrolling in our training programmes, purchasing
            equipment/consumables, or using our repair services, you agree to
            these Terms. These apply to all dealings with{" "}
            <strong>CHAOL CARINGTON Ltd</strong> (CAC-registered, Abuja).
          </p>

          <div className="legal__section">
            <h2 className="legal__section__title">
              1. Registration & Training Enrolment
            </h2>
            <ul className="legal__list">
              <li>
                Students must meet basic entry requirements (e.g., SSCE/WAEC or
                equivalent for Nursing Assistant and Technician courses).
              </li>
              <li>
                Submit accurate personal details during registration. We may
                request ID/proof of qualifications and may visit institutions to
                verify submitted credentials.
              </li>
              <li>
                Fees are payable in full or instalments before classes start.
                Fees are <strong>non-refundable</strong> after commencement,
                except in cases of our cancellation.
              </li>
              <li>
                We reserve the right to cancel or reschedule classes with at
                least 12 hours' notice. No refunds for no-shows.
              </li>
              <li>
                Students must attend at least <strong>80%</strong> of sessions,
                follow rules, and complete assessments for certification.
                Misconduct may lead to expulsion without refund.
              </li>
              <li>
                Certificates are issued only upon successful completion and full
                payment.
              </li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">
              2. Purchase of Medical Equipment & Consumables
            </h2>
            <ul className="legal__list">
              <li>
                All sales are final once delivered/issued. No returns except for
                manufacturing defects (within 7 days with proof).
              </li>
              <li>
                Prices are in NGN and subject to change without notice. We
                accept bank transfer, cash (in-person), or mobile payment.
              </li>
              <li>
                Equipment comes with manufacturer warranty (usually 3–12
                months). We handle repairs under warranty.
              </li>
              <li>
                Consumables (e.g., test kits) are for{" "}
                <strong>screening only</strong> — not diagnostic. Follow
                instructions and consult professionals.
              </li>
              <li>
                We are not liable for misuse, improper installation, or indirect
                losses.
              </li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">
              3. Repair, Calibration & Installation Services
            </h2>
            <ul className="legal__list">
              <li>
                Inspection, diagnostic and transportation fees are paid before
                our team of engineers visit facilities.
              </li>
              <li>
                Repairs are quoted after diagnosis. Work begins only after
                approval and a <strong>50% deposit</strong>.
              </li>
              <li>
                Full payment is made immediately after services are provided in
                full.
              </li>
              <li>
                Warranty on repairs: 1–2 weeks on parts/labour (varies by item).
                No liability for pre-existing issues or customer misuse.
              </li>
              <li>
                Transportation must be paid for all visits to any facility.
              </li>
            </ul>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">
              4. Liability & Governing Law
            </h2>
            <p className="legal__text">
              We provide services with reasonable care but are not liable for
              indirect damages, health outcomes from misuse, or losses beyond
              our control. These Terms are governed by Nigerian law. Disputes
              shall be resolved in Abuja courts.
            </p>
          </div>

          <div className="legal__section">
            <h2 className="legal__section__title">5. Changes to These Terms</h2>
            <p className="legal__text">
              We may update these Terms at any time. Continued use of our
              services means acceptance of the updated Terms.
            </p>
          </div>

          <div className="legal__contact">
            <h3>Contact Us</h3>
            <p>
              Email:{" "}
              <a href="mailto:chaolcarington1@gmail.com">
                chaolcarington1@gmail.com
              </a>
            </p>
            <p>Phone: 0704 141 0503</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
